import { FormControl, type FormGroup } from "@angular/forms";
import { ReplaySubject, Subject, takeUntil } from "rxjs";
import { IdName } from "../dtos/IdName";


export class SingleSelectSearch<T extends IdName> {
    public filterCtrl: FormControl<string> = new FormControl<string>('', { nonNullable: true });
    public filteredOptions: ReplaySubject<T[]> = new ReplaySubject<T[]>(1);

    public _onDestroy = new Subject<void>();

    constructor(private options: T[]) {
        this.filteredOptions.next(this.options.slice());

        this.filterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
            this.filterOptions();
        });
    }

    protected filterOptions() {
        if (!this.options) {
            return;
        }
        // get the search keyword
        let search = this.filterCtrl.value;
        if (!search) {
            this.filteredOptions.next(this.options.slice());
            return;
        } else {
            search = search.toLowerCase();
        }
        // // filter the options
        this.filteredOptions.next(
            this.options.filter(option => option.name && option.name.toLowerCase().indexOf(search) > -1) // Limit to 10 results
        );
    }

    setOptions(options: T[]): void {
        this.options = options;
        this.filterOptions();
    }
}